import React from "react";
import { useState } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Col,
} from "reactstrap";
import swal from 'sweetalert';
import BankAccItemBody from "./BankAccItemBody";
import { getSelectedBankTrans, getInvestorTransactionsByName, getInvestorTransactionsRange } from "../../util/APIUtils";
import BankTransferModal from "./BankTransferModal";
import { saveInvestorTransaction } from "../../util/APIUtils";
import InvestorsDetailBody from "./InvestorsDetailBody";
import AddInvestorScreen from "./AddInvestorScreen";
import { ButtonStyles } from "../../constants/ButtonStyles";

const options = {
  sortIndicator: true,
  hideSizePerPage: false,
  paginationSize: 3,
  hidePageListOnlyOnePage: false,
  clearSearch: true,
  alwaysShowAllBtns: true,
  withFirstAndLast: true,
};

export default function InvestorsBody({
  data,
  transferPayment,
  onChangeTransfer,
  cancel,
  updateTransfer,
  toggle,
  modal,
  fromBank,
  meta,
  refreshData,
  refreshMeta,
}) {
  const [contextMenuOpen, setContextMenuOpen] = useState(false);
  const [currentRow, setCurrentRow] = useState({});
  const [contextMenuPosition, setContextMenuPosition] = useState({
    x: 0,
    y: 0,
  });
  const [flag, setFlag] = useState(true);
  const [items, setItems] = useState([]);
  const [showAddScreen, setShowAddScreen] = useState(false);
  const [form, setForm] = useState({
    investorName: "",
    transactionAmount: "",
    transactionDate: new Date().toISOString().substring(0, 10),
    type: "",
    transactionCategory: "",
    description: "",
  });
  const [formErrors, setFormErrors] = useState({});

  const openAddScreen = () => setShowAddScreen(true);
  const closeAddScreen = () => {
    setShowAddScreen(false);
    setFormErrors({});
    setForm({
      investorName: "",
      transactionAmount: "",
      transactionDate: new Date().toISOString().substring(0, 10),
      type: "",
      transactionCategory: "",
      description: "",
    });
  };

  const onFormChange = ({ target }) => {
    const { name, value } = target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    const e = {};
    if (!form.investorName) e.investorName = 'Investor is required';
    if (!form.transactionAmount || isNaN(Number(form.transactionAmount))) e.transactionAmount = 'Valid amount is required';
    if (!form.transactionDate) e.transactionDate = 'Date is required';
    if (!form.type) e.type = 'Type is required';
    if (!form.transactionCategory) e.transactionCategory = 'Category is required';
    if (!form.description) e.description = 'Description is required';
    setFormErrors(e);
    return Object.keys(e).length === 0;
  };

  const submitForm = () => {
    if (!validateForm()) return;
    const payload = {
      investorName: form.investorName,
      transactionAmount: form.transactionAmount,
      transactionDate: form.transactionDate,
      type: form.type,
      transactionCategory: form.transactionCategory,
      description: form.description

    };
    saveInvestorTransaction(payload)
      .then(() => {
        swal('Transaction saved! You can add another transaction.');
        // Reset form for next entry, stay on same screen
        setForm({
          investorName: "",
          transactionAmount: "",
          transactionDate: new Date().toISOString().substring(0, 10),
          type: "",
          transactionCategory: "",
          description: "",
        });
        setFormErrors({});
        if (typeof refreshData === 'function') refreshData();
      })
      .catch(err => swal('Save error: ' + (err.message || err)));
  };

  const handleMenuItemClick = (action, row) => {
    setContextMenuOpen(false);
    if (action === 1) {
      loadItems(row);
    }
    if (action === 2) {
      showInvestorRangeFilter(row);
    }
  };

  // Display a swal date-range picker and fetch transactions for the selected investor
  const showInvestorRangeFilter = (row) => {
    const name = row.investorName || row.name || row.investor || '';
    if (!name) {
      swal('Investor name not found');
      return;
    }

    // build DOM content for swal
    const container = document.createElement('div');
    container.style.display = 'flex';
    container.style.flexDirection = 'column';
    container.style.gap = '6px';

    const lblFrom = document.createElement('label');
    lblFrom.textContent = 'From (yyyy-MM-dd)';
    const fromInput = document.createElement('input');
    fromInput.type = 'date';
    fromInput.style.width = '100%';
    fromInput.value = new Date().toISOString().substring(0, 10);

    const lblTo = document.createElement('label');
    lblTo.textContent = 'To (yyyy-MM-dd)';
    const toInput = document.createElement('input');
    toInput.type = 'date';
    toInput.style.width = '100%';
    toInput.value = new Date().toISOString().substring(0, 10);

    container.appendChild(lblFrom);
    container.appendChild(fromInput);
    container.appendChild(lblTo);
    container.appendChild(toInput);

    swal({
      title: `Filter transactions for ${name}`,
      content: container,
      buttons: {
        cancel: true,
        confirm: { text: 'Apply', closeModal: false },
      },
    }).then((apply) => {
      if (!apply) return;
      const from = fromInput.value;
      const to = toInput.value;
      if (!from || !to) {
        swal('Please select both From and To dates');
        return;
      }
      if (from > to) {
        swal('From date must be before or equal to To date');
        return;
      }
      swal({ title: 'Loading...', buttons: false, closeOnClickOutside: false });
      getInvestorTransactionsRange(name, from, to)
        .then(data => {
          setItems(Array.isArray(data) ? data : (data.transactions || []));
          setFlag(false);
          swal.close();
        })
        .catch(err => {
          swal.close();
          swal('Error fetching transactions: ' + (err.message || err));
        });
    });
  };

  const back = () => {
    setFlag(!flag);
  };

  const loadItems = (row) => {
    // Fetch investor transactions by name and show details
    const name = row.investorName || row.name || row.investor || '';
    if (!name) {
      swal('Investor name not found');
      return;
    }
    swal({ title: 'Loading...', buttons: false, closeOnClickOutside: false });
    getInvestorTransactionsByName(name)
      .then(data => {
        setItems(Array.isArray(data) ? data : (data.transactions || []));
        setFlag(false); // switch to details view
        swal.close();
      })
      .catch(err => {
        swal.close();
        swal('Error fetching transactions: ' + (err.message || err));
      });
  };

  const handleRightClick = (e, row) => {
    //  e.preventDefault();
    setContextMenuPosition({ x: e.clientX, y: e.clientY });
    setContextMenuOpen(true);
    setCurrentRow(row);
  };

  const cellButton = (cell, row, enumObject, rowIndex) => {
    return (
      <span>
        <Button
          style={ButtonStyles.warningSm}
          id={"more" + rowIndex}
          onClick={(e) => handleRightClick(e, row)}
        >
          <i className="fa fa-ellipsis-v" style={{ marginRight: "5px" }} />
          Actions
        </Button>
      </span>
    );
  };
  return (
    <div>
      <BankTransferModal
        OnToggle={toggle}
        view={modal}
        updateTransfer={updateTransfer}
        options={data}
        onChangeTransfer={onChangeTransfer}
        cancel={cancel}
        transferPayment={transferPayment}
      />

      {/* Add Investor Screen */}
      {showAddScreen ? (
        <AddInvestorScreen
          onBack={closeAddScreen}
          form={form}
          onFormChange={onFormChange}
          onSubmit={submitForm}
          meta={meta}
          formErrors={formErrors}
          refreshMeta={refreshMeta}
        />
      ) : flag ? (
        <Card style={{
          borderRadius: "15px",
          boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
          border: "none",
          overflow: "hidden"
        }}>
          <CardHeader style={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            padding: "20px 25px",
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: "none"
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <i className="fa fa-users" style={{ fontSize: "24px", color: "#fff" }}></i>
              <strong style={{ fontSize: '1.2rem', color: "#fff" }}>Loan Accounts</strong>
            </div>
            <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
              <Button
                style={ButtonStyles.secondarySm}
                onClick={() => { if (typeof refreshData === 'function') refreshData(); }}
                title="Refresh"
              >
                <i className="fa fa-refresh" style={{ marginRight: "5px" }} />
                Refresh
              </Button>
              <Button
                style={ButtonStyles.successSm}
                onClick={openAddScreen}
              >
                <i className="fa fa-plus" style={{ marginRight: "5px" }} />
                Add New
              </Button>
            </div>
          </CardHeader>
          <CardBody style={{ padding: "25px" }}>
            {/* Summary Cards */}
            <Row style={{ marginBottom: "25px" }}>
              <Col md="4">
                <Card style={{
                  background: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
                  borderRadius: "12px",
                  border: "none",
                  padding: "20px",
                  color: "#fff"
                }}>
                  <div style={{ fontSize: "14px", opacity: "0.9" }}>Total Accounts</div>
                  <div style={{ fontSize: "28px", fontWeight: "700" }}>{data ? data.length : 0}</div>
                </Card>
              </Col>
              <Col md="4">
                <Card style={{
                  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  borderRadius: "12px",
                  border: "none",
                  padding: "20px",
                  color: "#fff"
                }}>
                  <div style={{ fontSize: "14px", opacity: "0.9" }}>Total Amount</div>
                  <div style={{ fontSize: "28px", fontWeight: "700" }}>
                    {data ? data.reduce((sum, item) => sum + (parseFloat(item.totalAmount) || 0), 0).toLocaleString() : 0}
                  </div>
                </Card>
              </Col>
              <Col md="4">
                <Card style={{
                  background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                  borderRadius: "12px",
                  border: "none",
                  padding: "20px",
                  color: "#fff"
                }}>
                  <div style={{ fontSize: "14px", opacity: "0.9" }}>Active Investors</div>
                  <div style={{ fontSize: "28px", fontWeight: "700" }}>{data ? data.length : 0}</div>
                </Card>
              </Col>
            </Row>

            <BootstrapTable
              data={data}
              version="4"
              condensed={true}
              striped
              hover
              pagination
              search
              options={options}
              exportCSV
              csvFileName="Loan_accounts.csv"
              tableStyle={{ borderRadius: "10px" }}
            >
              <TableHeaderColumn
                isKey
                dataField="id"
                export={false}
                hidden={true}
              >
                ID
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="investorName"
                csvHeader="investor_name"
                filter={{ type: "TextFilter", delay: 1000 }}
                dataSort
                tdStyle={{ whiteSpace: "normal" }}
                thStyle={{ whiteSpace: "normal" }}
              >
                Account name
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="totalAmount"
                csvHeader="totalAmount"
                filter={{ type: "TextFilter", delay: 1000 }}
                dataSort
                tdStyle={{ whiteSpace: "normal" }}
                thStyle={{ whiteSpace: "normal" }}
              >
                Total Amount
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="button"
                dataFormat={cellButton}
                hiddenOnInsert
                export={false}
              >
                Actions
              </TableHeaderColumn>
            </BootstrapTable>
          </CardBody>
        </Card>
      ) : (
        <InvestorsDetailBody data={items} onBack={back} />
      )}

      {contextMenuOpen && (
        <Dropdown
          isOpen={contextMenuOpen}
          toggle={() => setContextMenuOpen(false)}
          style={{
            position: "fixed",
            top: contextMenuPosition.y,
            left: contextMenuPosition.x,
          }}
        >
          <DropdownToggle
            tag="span"
            data-toggle="dropdown"
            aria-expanded={true}
          />
          <DropdownMenu>
            <DropdownItem onClick={() => handleMenuItemClick(1, currentRow)}>
              View Details
            </DropdownItem>
            <DropdownItem onClick={() => handleMenuItemClick(2, currentRow)}>
              By Filter
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/InvestorsBody.js